module.exports = __webpack_public_path__ + "img/744.edba63c4.jpg";